// hooks/useLangueInterfaceParam.js
// Lecture du paramètre WP `langueInterface` (fr/es/en), transmis via l'URL de l'iframe.
// Valide la valeur reçue : si absente ou invalide, retourne null.

import { useSearchParams } from 'react-router-dom';

const LANGUES_VALIDES = ['fr', 'es', 'en'];

export function useLangueInterfaceParam() {
  const [searchParams] = useSearchParams();
  const valeur = searchParams.get('langueInterface');
  return LANGUES_VALIDES.includes(valeur) ? valeur : null;
}
